"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDialog = void 0;
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const form_1 = require("../form/form");
const dialog_1 = require("../../components/dialog/dialog");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const prompt_context_1 = require("./prompt-context");
const prompt_provider_1 = require("./prompt-provider");
exports.PromptDialog = (0, react_1.forwardRef)(function PromptDialog({ prompt, onConfirm, onCancel, loading }, ref) {
    var _a, _b, _c;
    const formRef = (0, react_1.useRef)(null);
    const closePrompt = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        if (ref !== null) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
        }
    });
    const resolveConfirm = (0, event_callback_hook_1.useEventCallback)(async () => {
        var _a, _b;
        if (!formRef.current) {
            const result = await onConfirm(undefined, formRef);
            return !result;
        }
        const errors = await ((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.validateForm());
        if ((errors === null || errors === void 0 ? void 0 : errors.length) === 0) {
            const values = (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getFieldValues();
            // dialog stays opened if result === true
            const result = await onConfirm(values, formRef);
            return !result;
        }
        else {
            return false;
        }
    });
    const handleDialogConfirm = (0, event_callback_hook_1.useEventCallback)(async () => {
        return resolveConfirm();
    });
    const handleCustomConfirm = (0, event_callback_hook_1.useEventCallback)(async () => {
        const canClose = await resolveConfirm();
        if (canClose) {
            closePrompt();
        }
        return canClose;
    });
    const handleCancel = (0, event_callback_hook_1.useEventCallback)(() => {
        closePrompt();
        onCancel();
    });
    const handleSubmit = (0, event_callback_hook_1.useEventCallback)(async (values, helpers) => {
        if (prompt === null || prompt === void 0 ? void 0 : prompt.formOnSubmit) {
            prompt === null || prompt === void 0 ? void 0 : prompt.formOnSubmit(values, helpers);
        }
        else {
            await handleCustomConfirm();
        }
    });
    return (react_1.default.createElement(prompt_context_1.PromptDialogContext.Provider, { value: {
            formRef,
            handleConfirm: handleCustomConfirm,
            handleCancel,
            loading,
        } },
        react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: prompt === null || prompt === void 0 ? void 0 : prompt.dialogTitle, maxWidth: prompt === null || prompt === void 0 ? void 0 : prompt.dialogMaxWidth, showConfirm: (_a = prompt === null || prompt === void 0 ? void 0 : prompt.dialogShowConfirm) !== null && _a !== void 0 ? _a : true, onConfirm: handleDialogConfirm, confirmLabel: prompt === null || prompt === void 0 ? void 0 : prompt.confirmLabel, showClose: (_b = prompt === null || prompt === void 0 ? void 0 : prompt.dialogShowClose) !== null && _b !== void 0 ? _b : true, onCancel: onCancel, closeLabel: prompt === null || prompt === void 0 ? void 0 : prompt.closeLabel, actions: prompt === null || prompt === void 0 ? void 0 : prompt.dialogActions, loading: loading, disableBackdrop: (_c = prompt === null || prompt === void 0 ? void 0 : prompt.dialogDisableBackdrop) !== null && _c !== void 0 ? _c : false }, () => {
            var _a, _b;
            return (react_1.default.createElement("div", { style: {
                    width: (_a = prompt === null || prompt === void 0 ? void 0 : prompt.dialogWidth) !== null && _a !== void 0 ? _a : 400,
                    maxWidth: typeof (prompt === null || prompt === void 0 ? void 0 : prompt.dialogWidth) === 'string' ? '100%' : undefined,
                } },
                !!(prompt === null || prompt === void 0 ? void 0 : prompt.dialogText) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Typography_1.default, { component: "div" }, prompt === null || prompt === void 0 ? void 0 : prompt.dialogText),
                    react_1.default.createElement("br", null))),
                (prompt === null || prompt === void 0 ? void 0 : prompt.FormFields) !== undefined && (react_1.default.createElement(prompt_provider_1.PromptProvider, null,
                    react_1.default.createElement(form_1.Form, { ref: formRef, editing: true, initialValues: (_b = prompt === null || prompt === void 0 ? void 0 : prompt.formInitialValues) !== null && _b !== void 0 ? _b : {}, onSubmit: handleSubmit, validationSchema: prompt.formValidationSchema }, react_1.default.createElement(prompt.FormFields, { onConfirm: handleCustomConfirm, onCancel: handleCancel, loading: loading }))))));
        })));
});
//# sourceMappingURL=prompt-dialog.js.map